export default __webpack_public_path__ + "static/media/Vinyl.97bcb1c6.png";